import Vue from 'vue'
import Router from 'vue-router'
import Document from '@/views/pc/document/index.vue'
import ExportCenter from "@/views/pc/exportCenter/index.vue";
import store from '@/store'
import {
  getSnaphotId,
  getToken,
  getUserUUID,
  setHasPackage,
  setHeadImg,
  setIsAuthOfficial,
  setIsBasic,
  setIsOver,
  setPlatformName,
  setPlatformUuid,
  setSnapshotId
} from '@/utils/auth'
import Error from '@/views/error/Index.vue'
import official from '@/javaApi/official'

const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace

const officialModel = new official()
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

let newPath = 'pc/home'
// 去除手机端适配
if (false && navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
  let newPath = 'h5/home'
}
Vue.use(Router)
const router = new Router({
  routes: [{
    path: '/',
    redirect: newPath
  },
    {
      path: 'pc/home/index',
      component: () => import('@/views/pc/home/Index.vue'),
      children: [{
        path: '/pc/home',
        name: 'pc/home',
        component: () => import('@/views/pc/home/Index.vue'),
        meta: {
          title: '主页',
          isRequireLogin: false,
          activeIndex: 0
        }
      }]
    },
    {
      path: 'pc/proxyHome/index',
      component: () => import('@/views/pc/proxyHome/index.vue'),
      children: [{
        path: '/pc/proxyHome/index',
        name: '/pc/proxyHome/inde',
        component: () => import('@/views/pc/proxyHome/index.vue'),
        meta: {
          title: '主页',
          isRequireLogin: false,
          activeIndex: 0
        }
      }]
    },
    {
      path: '/pc/pay/list',
      name: 'PayList',
      component: () => import('@/views/pc/pay/List.vue'),
      meta: {
        title: '支付订单',
        isRequireLogin: false,
        // activeIndex: 5
      }
    },
    {
      path: '/pc/pay/alipay',
      name: 'Alipay',
      component: () => import('@/views/pc/pay/Alipay.vue'),
      meta: {
        title: '支付宝支付',
        isRequireLogin: false,
        // activeIndex: 5
      }
    },
    {
      path: 'h5/home/index',
      component: () => import('@/views/h5/home/Index.vue'),
      children: [{
        path: '/h5/home',
        name: 'h5/home',
        component: () => import('@/views/h5/home/Index.vue'),
        meta: {
          title: '主页',
          isRequireLogin: false,
          activeIndex: 0
        }
      }]
    },
    {
      path: 'h5/login/index',
      component: () => import('@/views/h5/login/Index.vue'),
      children: [{
        path: '/h5/login',
        name: 'h5/login',
        component: () => import('@/views/h5/login/Index.vue'),
        meta: {
          title: '登录',
          isRequireLogin: false,
          activeIndex: 0
        }
      }]
    },
    {
      path: 'pc/register',
      component: () => import('@/views/pc/register/Index.vue'),
      children: [{
        path: '/pc/register',
        name: 'pc/register',
        component: () => import('@/views/pc/register/Index.vue'),
        meta: {
          title: '注册',
          isRequireLogin: false,
          activeIndex: 0
        }
      }]
    },
    {
      path: 'h5/register/index',
      component: () => import('@/views/h5/register/Index.vue'),
      children: [{
        path: '/h5/register',
        name: 'h5/register',
        component: () => import('@/views/h5/register/Index.vue'),
        meta: {
          title: '注册',
          isRequireLogin: false,
          activeIndex: 0
        }
      }]
    },
    {
      path: '/pc/resetPwd',
      component: () => import('@/views/pc/promotion/setting/Index.vue'),
      children: [{
        path: '/pc/resetPwd',
        name: 'pc/resetPwd',
        component: () => import('@/views/pc/promotion/setting/Index.vue'),
        meta: {
          title: '个人设置',
          isRequireLogin: false,
          activeIndex: 0
        }
      }]
    },
    {
      path: '/h5/resetPwd',
      component: () => import('@/views/h5/resetPwd/Index.vue'),
      children: [{
        path: '/h5/resetPwd',
        name: 'h5/resetPwd',
        component: () => import('@/views/h5/resetPwd/Index.vue'),
        meta: {
          title: '找回设置',
          isRequireLogin: false,
          activeIndex: 0
        }
      }]
    },
    {
      path: 'h5/contact',
      component: () => import('@/views/h5/contact/Index.vue'),
      children: [{
        path: '/h5/contact',
        name: 'h5/contact',
        component: () => import('@/views/h5/contact/Index.vue'),
        meta: {
          title: '',
          isRequireLogin: false,
          activeIndex: 0
        }
      }]
    },
    {
      path: 'h5/pay/index',
      component: () => import('@/views/h5/pay/Index.vue'),
      children: [{
        path: '/h5/pay',
        name: 'h5/pay',
        component: () => import('@/views/h5/pay/Index.vue'),
        meta: {
          title: '支付完成',
          isRequireLogin: false,
          activeIndex: 0
        }
      }]
    },
    {
      path: '/pc/promotion',
      component: () => import('@/views/pc/promotion/Index.vue'),
      children: [{
        path: '/pc/promotion/home',
        name: 'pc/promotion/home',
        component: () => import('@/views/pc/promotion/home/Index.vue'),
        meta: {
          title: '推广主页',
          isRequireLogin: true,
          activeIndex: 1
        }
      },
        {
          path: '/pc/promotion/manage',
          name: 'pc/promotion/manage',
          component: () => import('@/views/pc/promotion/manage/Index.vue'),
          meta: {
            title: '推广位管理',
            isRequireLogin: true,
            activeIndex: 1
          }
        },
        {
          path: '/pc/promotion/report',
          name: 'pc/promotion/report',
          component: () => import('@/views/pc/promotion/report/Index.vue'),
          meta: {
            title: '推广位报表',
            isRequireLogin: true,
            activeIndex: 1
          }
        },
        {
          path: '/pc/promotion/order',
          name: 'pc/promotion/order',
          component: () => import('@/views/pc/promotion/order/Index.vue'),
          meta: {
            title: '推广订单',
            isRequireLogin: true,
            activeIndex: 1
          }
        },
        {
          path: '/pc/promotion/taobaoOrderError',
          name: 'pc/promotion/order',
          component: () => import('@/views/pc/bypassAccountOrder/taobaoOrderError.vue'),
          meta: {
            title: '淘宝订单人工纠错',
            isRequireLogin: true,
            activeIndex: 1
          }
        },
        {
          path: '/pc/promotion/money',
          name: 'pc/promotion/money',
          component: () => import('@/views/pc/promotion/money/Index.vue'),
          meta: {
            title: '资金明细',
            isRequireLogin: true,
            activeIndex: 1
          }
        },
        {
          path: '/pc/promotion/account',
          name: 'pc/promotion/account',
          component: () => import('@/views/pc/promotion/account/Index.vue'),
          meta: {
            title: '账户充值',
            isRequireLogin: true,
            activeIndex: 1
          }
        },
        {
          path: '/pc/promotion/setting',
          name: 'pc/promotion/setting',
          component: () => import('@/views/pc/promotion/setting/Index.vue'),
          meta: {
            title: '个人设置',
            isRequireLogin: true,
            activeIndex: 1
          }
        },
        {
          path: '/pc/accountNumber',
          name: 'pc/accountNumber',
          component: () => import('@/views/pc/promotion/accountNumber/index.vue'),
          meta: {
            title: '账号列表',
            isRequireLogin: false,
            activeIndex: 0
          }
        },

    ]
  },
    {
      path: '/h5/exportCenter',
      component: () => import('@/views/h5/exportCenter/index.vue'),
      children: [{
        path: '/h5/exportCenter/index',
        name: 'ExportCenterIndexH5',
        component: () => import('@/views/h5/exportCenter/exportList/index'),
        meta: {
          title: '导出中心',
          isRequireLogin: true,
          activeIndex: 1
        }
      }],
    },
  {
    path: '/h5/promotion/home',
    component: () => import('@/views/h5/promotion/Index.vue'),
    children: [{
      path: '/h5/promotion/home',
      name: 'h5/promotion/home',
      component: () => import('@/views/h5/promotion/home/Index.vue'),
      meta: {
        title: '推广主页',
        isRequireLogin: true,
        activeIndex: 1
      }
    }]
  },
  {
    path: '/h5/promotion/manage',
    component: () => import('@/views/h5/promotion/Index.vue'),
    children: [{
      path: '/h5/promotion/manage',
      name: 'h5/promotion/manage',
      component: () => import('@/views/h5/promotion/manage/Index.vue'),
      meta: {
        title: '推广位管理',
        isRequireLogin: true,
        activeIndex: 1
      }
    }]
  },
  {
    path: '/h5/promotion/report',
    component: () => import('@/views/h5/promotion/Index.vue'),
    children: [{
      path: '/h5/promotion/report',
      name: 'h5/promotion/report',
      component: () => import('@/views/h5/promotion/report/Index.vue'),
      meta: {
        title: '推广位报表',
        isRequireLogin: true,
        activeIndex: 1
      }
    }]
  },
  {
    path: '/h5/promotion/order',
    component: () => import('@/views/h5/promotion/Index.vue'),
    children: [{
      path: '/h5/promotion/order',
      name: 'h5/promotion/order',
      component: () => import('@/views/h5/promotion/order/Index.vue'),
      meta: {
        title: '推广订单',
        isRequireLogin: true,
        activeIndex: 1
      }
    }]
  },
  {
    path: '/h5/promotion/money',
    component: () => import('@/views/h5/promotion/Index.vue'),
    children: [{
      path: '/h5/promotion/money',
      name: 'h5/promotionm/oney',
      component: () => import('@/views/h5/promotion/money/Index.vue'),
      meta: {
        title: '资金明细',
        isRequireLogin: true,
        activeIndex: 1
      }
    }]
  },
  {
    path: '/h5/promotion/account',
    component: () => import('@/views/h5/promotion/Index.vue'),
    children: [{
      path: '/h5/promotion/account',
      name: 'h5/promotion/account',
      component: () => import('@/views/h5/promotion/account/Index.vue'),
      meta: {
        title: '账户充值',
        isRequireLogin: true,
        activeIndex: 1
      }
    }]
  },
  {
    path: '/h5/promotion/setting',
    component: () => import('@/views/h5/promotion/Index.vue'),
    children: [{
      path: '/h5/promotion/setting',
      name: 'h5/promotion/setting',
      component: () => import('@/views/h5/promotion/setting/Index.vue'),
      meta: {
        title: '个人设置',
        isRequireLogin: true,
        activeIndex: 1
      }
    }]
  },
  {
    path: '/pc/document',
    component: Document,
    children: [{
      path: '/pc/document/user',
      name: 'DocumentUserApply',
      component: () => import('@/views/pc/document/user/index'),
      meta: {
        title: '我的应用',
        isRequireLogin: true,
        activeIndex: 2
      }
    },
    {
      path: '/pc/document/guide',
      name: 'DocumentGuide',
      component: () => import('@/views/pc/document/guide/index'),
      meta: {
        title: 'API申请指南',
        isRequireLogin: true,
        activeIndex: 2
      }
    },
    {
      path: '/pc/document/contact',
      name: 'DocumentContact',
      component: () => import('@/views/pc/document/contact/index'),
      meta: {
        title: 'API列表',
        isRequireLogin: true,
        activeIndex: 2
      }
    },
    {
      path: '/pc/document/api/:hash',
      name: 'DocumentApi',
      component: () => import('@/views/pc/document/api/index'),
      meta: {
        title: 'API列表',
        isRequireLogin: true,
        roles: 'developer',
        activeIndex: 2
      }
    },
    ],
  },
  {
    path: '/pc/exportCenter',
    component: ExportCenter,
    children: [{
      path: '/pc/exportCenter/index',
      name: 'ExportCenterIndex',
      component: () => import('@/views/pc/export/index'),
      meta: {
        title: '导出中心',
        isRequireLogin: true,
        activeIndex: 1
      }
    }],
  },
  {
    path: '/pc/official/home',
    name: 'officialIndex',
    component: () => import('@/views/pc/official/home/Index.vue'),
    meta: {
      title: '公众号入驻',
      isRequireLogin: false,
      activeIndex: 5
    }
  },
  {
    path: '/h5/official/home',
    name: 'officialIndex',
    component: () => import('@/views/h5/official/home/Index.vue'),
    meta: {
      title: '公众号入驻',
      isRequireLogin: false,
      activeIndex: 5
    }
  },
  {
    path: '/pc/official',
    component: () =>
      import('@/views/pc/official/Index.vue'),
    children: [{
      path: '/pc/official/invite',
      name: 'Invite',
      component: () =>
        import('@/views/pc/official/invite/Index.vue'),
      meta: {
        title: '网站推广',
        isRequireLogin: true,
        activeIndex: 5
      }
    },
    {
      path: '/pc/official/statistics',
      name: 'Wechat',
      component: () =>
        import('@/views/pc/official/statistics/Index.vue'),
      meta: {
        title: '公众号主页',
        isRequireLogin: true,
        activeIndex: 5
      }
    },
    {
      path: '/pc/official/mywechat',
      name: 'MyWechat',
      component: () =>
        import('@/views/pc/official/mywechat/Index.vue'),
      meta: {
        title: '我的公众号',
        isRequireLogin: true,
        activeIndex: 5
      }
    },
    {
      path: '/pc/official/member',
      name: 'Member',
      component: () =>
        import('@/views/pc/official/member/Index.vue'),
      meta: {
        title: '我的会员',
        isRequireLogin: true,
        activeIndex: 5
      }
    },
    {
      path: '/pc/official/order',
      name: 'Order',
      component: () =>
        import('@/views/pc/official/order/Index.vue'),
      meta: {
        title: '推广订单',
        isRequireLogin: true,
        activeIndex: 5
      }
    },
    {
      path: '/pc/official/sort',
      name: 'Sort',
      component: () =>
        import('@/views/pc/official/sort/Index.vue'),
      meta: {
        title: '会员排名',
        isRequireLogin: true,
        activeIndex: 5
      }
    },
    {
      path: '/pc/official/mingxi',
      name: 'Mingxi',
      component: () =>
        import('@/views/pc/official/mingxi/Index.vue'),
      meta: {
        title: '收益明细',
        isRequireLogin: true,
        activeIndex: 5
      }
    },
    {
      path: '/pc/official/authorization',
      name: 'Authorization',
      component: () =>
        import('@/views/pc/official/authorization/Index.vue'),
      meta: {
        title: '公众号授权',
        isRequireLogin: true,
        activeIndex: 5
      }
    },
    {
      path: '/pc/official/dialog',
      name: 'Activation',
      component: () =>
        import('@/views/pc/official/activation/Index.vue'),
      meta: {
        title: '激活续费',
        isRequireLogin: true,
        activeIndex: 5
      }
    },
    {
      path: '/pc/official/withdraw',
      name: 'Withdraw',
      component: () =>
        import('@/views/pc/official/withdraw/Index.vue'),
      meta: {
        title: '提现记录',
        isRequireLogin: true,
        activeIndex: 5
      }
    },
    {
      path: '/pc/official/set',
      name: 'Set',
      component: () =>
        import('@/views/pc/official/set/Index.vue'),
      meta: {
        title: '设置',
        isRequireLogin: true,
        activeIndex: 5
      }
    },
    {
      path: '/pc/official/commission',
      name: 'official/commission',
      component: () =>
        import('@/views/pc/official/commission/Index.vue'),
      meta: {
        title: '佣金提现记录',
        isRequireLogin: true,
        activeIndex: 5
      }
    },
    ],
  },
  {
    path: '/h5/official',
    component: () => import('@/views/h5/official/Index.vue'),
    children: [
      {
        path: '/h5/official/statistics',
        name: 'statistics',
        component: () => import('@/views/h5/official/statistics/Index.vue'),
        meta: {
          title: '公众号主页',
          isRequireLogin: true,
          activeIndex: 5
        }
      },
      {
        path: '/h5/official/invite',
        name: 'Invite',
        component: () => import('@/views/h5/official/invite/Index.vue'),
        meta: {
          title: '网站推广',
          isRequireLogin: true,
          activeIndex: 5
        }
      },
      {
        path: '/h5/official/member',
        name: 'Member',
        component: () => import('@/views/h5/official/member/Index.vue'),
        meta: {
          title: '我的会员',
          isRequireLogin: true,
          activeIndex: 5
        }
      },
      {
        path: '/h5/official/order',
        name: 'Order',
        component: () => import('@/views/h5/official/order/index.vue'),
        meta: {
          title: '推广订单',
          isRequireLogin: true,
          activeIndex: 5
        }
      },
      {
        path: '/h5/official/sort',
        name: 'Sort',
        component: () => import('@/views/h5/official/sort/Index.vue'),
        meta: {
          title: '会员排名',
          isRequireLogin: true,
          activeIndex: 5
        }
      },
      {
        path: '/h5/official/mingxi',
        name: 'Mingxi',
        component: () => import('@/views/h5/official/mingxi/Index.vue'),
        meta: {
          title: '收益明细',
          isRequireLogin: true,
          activeIndex: 5
        }
      },
      {
        path: '/h5/official/commission',
        name: 'Commission',
        component: () => import('@/views/h5/official/commission/Index.vue'),
        meta: {
          title: '佣金提现审核',
          isRequireLogin: true,
          activeIndex: 5
        }
      },
      {
        path: '/h5/official/authorization',
        name: 'Authorization',
        component: () => import('@/views/h5/official/authorization/Index.vue'),
        meta: {
          title: '公众号授权',
          isRequireLogin: true,
          activeIndex: 5
        }
      },
      {
        path: '/h5/official/dialog',
        name: 'Activation',
        component: () => import('@/views/h5/official/activation/Index.vue'),
        meta: {
          title: '激活缴费',
          isRequireLogin: true,
          activeIndex: 5
        }
      },
      {
        path: '/h5/official/withdraw',
        name: 'Withdraw',
        component: () => import('@/views/h5/official/withdraw/Index.vue'),
        meta: {
          title: '提现记录',
          isRequireLogin: true,
          activeIndex: 5
        }
      },
      {
        path: '/h5/official/set',
        name: 'Set',
        component: () => import('@/views/h5/official/set/Index.vue'),
        meta: {
          title: '设置',
          isRequireLogin: true,
          activeIndex: 5
        }
      },
    ],
  },
  {
    path: '/pc/official/authsuccess',
    name: 'official/authsuccess',
    component: () =>
      import('@/views/pc/official/authsuccess/Index.vue'),
    meta: {
      title: '授权成功',
      isRequireLogin: true,
      activeIndex: 5
    }
  },
  {
    path: '/pc/kfc/home',
    name: 'kfcIndex',
    component: () => import('@/views/pc/kfc/home/Index.vue'),
    meta: {
      title: '肯德基推广',
      isRequireLogin: false,
      activeIndex: 6
    }
  },
  {
    path: '/pc/open/login',
    name: 'openIndex',
    component: () => import('@/views/pc/open/login.vue'),
    meta: {
      title: '品牌商城',
      isRequireLogin: false,
      activeIndex: 8
    }
  },
  {
    path: '/pc/kfc/authsuccess',
    name: 'kfc/authsuccess',
    component: () =>
      import('@/views/pc/kfc/authsuccess/Index.vue'),
    meta: {
      title: '授权成功',
      isRequireLogin: true,
      activeIndex: 6
    }
  },
  {
    path: '/pc/kfc',
    component: () =>
      import('@/views/pc/kfc/Index.vue'),
    children: [
      {
        path: '/pc/kfc/statistics',
        name: 'Wechat',
        component: () =>
          import('@/views/pc/kfc/statistics/Index.vue'),
        meta: {
          title: '主页',
          isRequireLogin: true,
          activeIndex: 6
        }
      },
      {
        path: '/pc/kfc/invite',
        name: 'Invite',
        component: () =>
          import('@/views/pc/kfc/invite/Index.vue'),
        meta: {
          title: '网站推广',
          isRequireLogin: true,
          activeIndex: 6
        }
      },
      {
        path: '/pc/kfc/member',
        name: 'Member',
        component: () =>
          import('@/views/pc/kfc/member/Index.vue'),
        meta: {
          title: '肯德基会员',
          isRequireLogin: true,
          activeIndex: 6
        }
      },
      {
        path: '/pc/kfc/order',
        name: 'Order',
        component: () =>
          import('@/views/pc/kfc/order/Index.vue'),
        meta: {
          title: '推广订单',
          isRequireLogin: true,
          activeIndex: 6
        }
      },
      {
        path: '/pc/kfc/sort',
        name: 'Sort',
        component: () =>
          import('@/views/pc/kfc/sort/Index.vue'),
        meta: {
          title: '会员排名',
          isRequireLogin: true,
          activeIndex: 6
        }
      },
      {
        path: '/pc/kfc/authorization',
        name: 'Authorization',
        component: () =>
          import('@/views/pc/kfc/authorization/Index.vue'),
        meta: {
          title: '公众号授权',
          isRequireLogin: true,
          activeIndex: 6
        }
      },
      {
        path: '/pc/kfc/mywechat',
        name: 'MyWechat',
        component: () =>
          import('@/views/pc/kfc/mywechat/Index.vue'),
        meta: {
          title: '肯德基公众号',
          isRequireLogin: true,
          activeIndex: 6
        }
      },
      {
        path: '/pc/kfc/withdraw',
        name: 'Withdraw',
        component: () =>
          import('@/views/pc/kfc/withdraw/Index.vue'),
        meta: {
          title: '提现记录',
          isRequireLogin: true,
          activeIndex: 6
        }
      },
    ],
  },
  {
    path: '/pc/open',
    component: () =>
      import('@/views/pc/open/index.vue'),
    children: [
      {
        path: '/pc/open/home',
        name: '/pc/open/home',
        component: () =>
          import('@/views/pc/open/home.vue'),
        meta: {
          title: '主页',
          isRequireLogin: true,
          activeIndex: 8
        }
      },
      {
        path: '/pc/open/member',
        name: '/pc/open/member',
        component: () =>
          import('@/views/pc/open/member.vue'),
        meta: {
          title: '会员列表',
          isRequireLogin: true,
          activeIndex: 8
        }
      },
      {
        path: '/pc/open/order',
        name: '/pc/open/order',
        component: () =>
          import('@/views/pc/open/order.vue'),
        meta: {
          title: '订单列表',
          isRequireLogin: true,
          activeIndex: 8
        }
      },
      {
        path: '/pc/open/record',
        name: '/pc/open/record',
        component: () =>
          import('@/views/pc/open/record.vue'),
        meta: {
          title: '流水记录',
          isRequireLogin: true,
          activeIndex: 8
        }
      },
      {
        path: '/pc/open/application',
        name: '/pc/open/application',
        component: () =>
          import('@/views/pc/open/application.vue'),
        meta: {
          title: '应用开通',
          isRequireLogin: true,
          activeIndex: 8
        }
      },
    ],
  },
  {
    path: '/pc/user',
    component: () =>
      import('@/views/pc/user/index.vue'),
    children: [
      // {
      //   path: '/pc/user/accountWithdrawal',
      //   name: '/pc/user/accountWithdrawal',
      //   component: () =>
      //     import('@/views/pc/user/accountWithdrawal'),
      //   meta: {
      //     title: '账户提现',
      //     isRequireLogin: true,
      //     activeIndex: 88
      //   }
      // },
      {
        path: '/pc/user/accountWithdrawal',
        name: '/pc/user/accountWithdrawal',
        component: () =>
          import('@/views/pc/user/account/Index.vue'),
        meta: {
          title: '账户提现',
          isRequireLogin: true,
          activeIndex: 88
        }
      },
      {
        path: '/pc/user/WithdrawalRecord',
        name: '/pc/user/WithdrawalRecord',
        component: () =>
          import('@/views/pc/user/WithdrawalRecord'),
        meta: {
          title: '提现记录',
          isRequireLogin: true,
          activeIndex: 88
        }
      },
      {
        path: '/pc/user/flowRecord',
        name: '/pc/user/flowRecord',
        component: () =>
          import('@/views/pc/user/flowRecord'),
        meta: {
          title: '流水记录',
          isRequireLogin: true,
          activeIndex: 88
        }
      },
      {
        path: '/pc/user/changePassword',
        name: '/pc/user/changePassword',
        component: () =>
          import('@/views/pc/user/changePassword'),
        meta: {
          title: '修改密码',
          isRequireLogin: true,
          activeIndex: 88
        }
      },
      {
        path: '/pc/user/account',
        name: '/pc/user/account',
        component: () =>
          import('@/views/pc/promotion/account/Index.vue'),
        meta: {
          title: '账户充值',
          isRequireLogin: true,
          activeIndex: 88
        }
      }, {
        path: '/pc/accountNumber/index',
        name: '/pc/accountNumber/index',
        component: () =>
          import('@/views/pc/promotion/accountNumber/index.vue'),
        meta: {
          title: '账户列表',
          isRequireLogin: true,
          activeIndex: 88
        }
      },
    ],
  },
  {
    path: '*',
    name: 'NotFount',
    component: Error
  },
  {
    path: '/pc/SaasJoin/index',
    name: 'index',
    component: () =>
      import('@/views/pc/SaasJoin/index.vue'),
    meta: {
      title: 'Saas加盟',
      isRequireLogin: true,
      activeIndex: 7
    },
    children: [
      {
        path: '/pc/SaasJoin/home/index',
        name: 'index',
        component: () =>
          import('@/views/pc/SaasJoin/home/index.vue'),
        meta: {
          title: '主页',
          isRequireLogin: true,
          activeIndex: 7
        },
      },
      {
        path: '/pc/SaasJoin/withdraw/index',
        name: 'index',
        component: () =>
          import('@/views/pc/SaasJoin/withdraw/index.vue'),
        meta: {
          title: '提现',
          isRequireLogin: true,
          activeIndex: 7
        },
      },
      {
        path: '/pc/SaasJoin/userList/index',
        name: 'index',
        component: () =>
          import('@/views/pc/SaasJoin/userList/index.vue'),
        meta: {
          title: '用户列表',
          isRequireLogin: true,
          activeIndex: 7
        },
      },
      {
        path: '/pc/SaasJoin/setTheOrder/index',
        name: 'index',
        component: () =>
          import('@/views/pc/SaasJoin/setTheOrder/index.vue'),
        meta: {
          title: '套餐订单',
          isRequireLogin: true,
          activeIndex: 7
        },
      },
      {
        path: '/pc/SaasJoin/official/index',
        name: 'index',
        component: () =>
          import('@/views/pc/SaasJoin/official/index.vue'),
        meta: {
          title: '公众号授权',
          isRequireLogin: true,
          activeIndex: 7
        },
      },
      {
        path: '/pc/SaasJoin/pay/index',
        name: 'index',
        component: () =>
          import('@/views/pc/SaasJoin/pay/index.vue'),
        meta: {
          title: '公众号授权',
          isRequireLogin: true,
          activeIndex: 7
        },
      },
      {
        path: '/pc/SaasJoin/pay/paymentStatus',
        name: 'paymentStatus',
        component: () =>
          import('@/views/pc/SaasJoin/pay/paymentStatus.vue'),
        meta: {
          title: '公众号授权',
          isRequireLogin: true,
          activeIndex: 7
        },
      },
      {
        path: '/pc/SaasJoin/ticketIn/index',
        name: 'paymentStatus',
        component: () =>
          import('@/views/pc/SaasJoin/ticketIn/index.vue'),
        meta: {
          title: '票务号授权',
          isRequireLogin: true,
          activeIndex: 7
        },
      },
      {
        path: '/pc/SaasJoin/assignRules/index',
        name: 'index',
        component: () =>
          import('@/views/pc/SaasJoin/assignRules/index.vue'),
        meta: {
          title: '指派规则',
          isRequireLogin: true,
          activeIndex: 7
        },
      },
      {
        path: '/pc/SaasJoin/assignRules/addRules',
        name: 'addRules',
        component: () =>
          import('@/views/pc/SaasJoin/assignRules/addRules.vue'),
        meta: {
          title: '新增规则',
          isRequireLogin: true,
          activeIndex: 7
        },
      },
      {
        path: '/pc/SaasJoin/financialDetails/index',
        name: 'index',
        component: () =>
          import('@/views/pc/SaasJoin/financialDetails/index.vue'),
        meta: {
          title: '资金明细',
          isRequireLogin: true,
          activeIndex: 7
        },
      },
      {
        path: '/pc/SaasJoin/moviePriceList/index',
        name: 'index',
        component: () =>
          import('@/views/pc/SaasJoin/moviePriceList/index.vue'),
        meta: {
          title: '影票定价',
          isRequireLogin: true,
          activeIndex: 7
        },
      }
    ]
  },
  {
    path: '/pc/miniProgram/',
    name: 'index',
    component: () =>
      import('@/views/pc/miniProgram/index.vue'),
    meta: {
      title: '我的小程序',
    },
    children: [
      {
        path: '/pc/miniProgram/home',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/home/index.vue'),
        meta: {
          title: '主页',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/xhsProductionCenter',
        name: 'index',
        component: () =>
            import('@/views/pc/miniProgram/xhsProductionCenter/index.vue'),
        meta: {
          title: '小红书商品中心',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/recharge',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/recharge/index.vue'),
        meta: {
          title: '提现',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/activate',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/activate/index.vue'),
        meta: {
          title: '激活续费',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/user',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/user/index.vue'),
        meta: {
          title: '用户列表',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/order',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/order/index.vue'),
        meta: {
          title: '小程序推广订单',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/groupOrder',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/groupOrder/index.vue'),
        meta: {
          title: '团购订单',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/intercept',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/intercept/index.vue'),
        meta: {
          title: '拦截订单列表',
          isRequireLogin: true,
        },
      }, {
        path: '/pc/miniProgram/audit',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/audit/index.vue'),
        meta: {
          title: '提现审核',
          isRequireLogin: true,
        },
      }, {
        path: '/pc/miniProgram/set',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/set/index.vue'),
        meta: {
          title: '基础设置',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/poiCps',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/poiCps/index.vue'),
        meta: {
          title: 'POI-CPS管理',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/poiCps/groupLeaderDistribution',
        name: 'index',
        component: () =>
            import('@/views/pc/miniProgram/poiCps/groupLeaderDistribution.vue'),
        meta: {
          title: '团长分销管理',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/financialDetails',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/financialDetails/index.vue'),
        meta: {
          title: '资金明细',
          isRequireLogin: true,
        },
      }, {
        path: '/pc/miniProgram/coupon',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/coupon/index.vue'),
        meta: {
          title: '优惠券管理',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/couponNew',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/couponNew/index.vue'),
        meta: {
          title: '优惠券管理',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/couponJd',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/couponJd/index.vue'),
        meta: {
          title: '京东福利券',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/ddCouponExchange',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/ddCouponExchange/index.vue'),
        meta: {
          title: '抖店兑换券',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/ddCouponExchangeNew',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/ddCouponExchangeNew/index.vue'),
        meta: {
          title: '抖店兑换券',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/ksCouponExchange',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/ksCouponExchange/index.vue'),
        meta: {
          title: '快手店兑换券',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/couponDy',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/couponDy/index.vue'),
        meta: {
          title: '抖音小程序券',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/couponGroup',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/couponGroup/index.vue'),
        meta: {
          title: '团购券',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/couponGroupNew',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/couponGroupNew/index.vue'),
        meta: {
          title: '团购券',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/couponTaoBao',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/couponTaoBao/index.vue'),
        meta: {
          title: '天猫券',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/couponTaoBaoNew',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/couponTaoBaoNew/index.vue'),
        meta: {
          title: '天猫券',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/couponDyPoi',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/couponDyPoi/index.vue'),
        meta: {
          title: 'POI专属',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/couponDyPoiNew',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/couponDyPoiNew/index.vue'),
        meta: {
          title: 'POI专属',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/promotionManage',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/promotionManage/index.vue'),
        meta: {
          title: '推广位管理',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/miniProgram/statisticalData',
        name: 'index',
        component: () =>
          import('@/views/pc/miniProgram/statisticalData/index.vue'),
        meta: {
          title: '统计数据',
          isRequireLogin: true,
        },
      }
    ]
  },
    {
    path: '/pc/miniProgram/auto',
    name: 'index',
    component: () =>
      import('@/views/pc/miniProgram/auto/index.vue'),
    meta: {
      title: '授权小程序',
      isRequireLogin: true,
    },
  }
    , {
      path: '/pc/miniProgram/pay',
      name: 'index',
      component: () =>
        import('@/views/pc/miniProgram/pay/index.vue'),
      meta: {
        title: '支付订单',
        isRequireLogin: true,
      },
    }, {
      path: '/pc/miniProgram/creditCard',
      name: 'index',
      component: () =>
        import('@/views/pc/miniProgram/creditCard/index.vue'),
      meta: {
        title: '购买席位',
        isRequireLogin: true,
      },
    },
    // === 支付宝

  {
    path: '/pc/zfbMiniProgram/',
    name: 'index',
    component: () =>
      import('@/views/pc/zfbMiniProgram/index.vue'),
    meta: {
      title: '我的小程序',
    },
    children: [
      {
        path: '/pc/zfbMiniProgram/home',
        name: 'index',
        component: () =>
          import('@/views/pc/zfbMiniProgram/home/index.vue'),
        meta: {
          title: '主页',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/zfbMiniProgram/recharge',
        name: 'index',
        component: () =>
          import('@/views/pc/zfbMiniProgram/recharge/index.vue'),
        meta: {
          title: '提现',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/zfbMiniProgram/activate',
        name: 'index',
        component: () =>
          import('@/views/pc/zfbMiniProgram/activate/index.vue'),
        meta: {
          title: '激活续费',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/zfbMiniProgram/user',
        name: 'index',
        component: () =>
          import('@/views/pc/zfbMiniProgram/user/index.vue'),
        meta: {
          title: '用户列表',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/zfbMiniProgram/order',
        name: 'index',
        component: () =>
          import('@/views/pc/zfbMiniProgram/order/index.vue'),
        meta: {
          title: '订单列表',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/zfbMiniProgram/intercept',
        name: 'index',
        component: () =>
          import('@/views/pc/zfbMiniProgram/intercept/index.vue'),
        meta: {
          title: '拦截订单列表',
          isRequireLogin: true,
        },
      }, {
        path: '/pc/zfbMiniProgram/audit',
        name: 'index',
        component: () =>
          import('@/views/pc/zfbMiniProgram/audit/index.vue'),
        meta: {
          title: '提现审核',
          isRequireLogin: true,
        },
      }, {
        path: '/pc/zfbMiniProgram/set',
        name: 'index',
        component: () =>
          import('@/views/pc/zfbMiniProgram/set/index.vue'),
        meta: {
          title: '基础设置',
          isRequireLogin: true,
        },
      }, {
        path: '/pc/zfbMiniProgram/financialDetails',
        name: 'index',
        component: () =>
          import('@/views/pc/zfbMiniProgram/financialDetails/index.vue'),
        meta: {
          title: '资金明细',
          isRequireLogin: true,
        },
      }, {
        path: '/pc/zfbMiniProgram/coupon',
        name: 'index',
        component: () =>
          import('@/views/pc/zfbMiniProgram/coupon/index.vue'),
        meta: {
          title: '优惠券管理',
          isRequireLogin: true,
        },
      }, {
        path: '/pc/zfbMiniProgram/promotionManage',
        name: 'index',
        component: () =>
          import('@/views/pc/zfbMiniProgram/promotionManage/index.vue'),
        meta: {
          title: '推广位管理',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/zfbMiniProgram/statisticalData',
        name: 'index',
        component: () =>
          import('@/views/pc/zfbMiniProgram/statisticalData/index.vue'),
        meta: {
          title: '统计数据',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/zfbMiniProgram/couponGroup',
        name: 'index',
        component: () =>
          import('@/views/pc/zfbMiniProgram/couponGroup/index.vue'),
        meta: {
          title: '支付宝优惠券',
          isRequireLogin: true,
        },
      },
      {
        path: '/pc/zfbMiniProgram/couponGroupNew',
        name: 'index',
        component: () =>
          import('@/views/pc/zfbMiniProgram/couponGroupNew/index.vue'),
        meta: {
          title: '支付宝优惠券',
          isRequireLogin: true,
        },
      },
    ]
  },
     {
    path: '/pc/zfbMiniProgram/auto',
    name: 'index',
    component: () =>
      import('@/views/pc/zfbMiniProgram/auto/index.vue'),
    meta: {
      title: '授权小程序',
      isRequireLogin: true,
    },
  }
    , {
      path: '/pc/zfbMiniProgram/pay',
      name: 'index',
      component: () =>
        import('@/views/pc/zfbMiniProgram/pay/index.vue'),
      meta: {
        title: '支付订单',
        isRequireLogin: true,
      },
    }, {
      path: '/pc/zfbMiniProgram/creditCard',
      name: 'index',
      component: () =>
        import('@/views/pc/zfbMiniProgram/creditCard/index.vue'),
      meta: {
        title: '购买席位',
        isRequireLogin: true,
      },
    },


    // ====支付宝
    {
      path: '/pc/bypassAccountOrder/index',
      name: 'index',
      component: () =>
        import('@/views/pc/bypassAccountOrder/index.vue'),
      meta: {
        title: '订单查询',
        isRequireLogin: true,
      },
      children: [
        {
          path: '/pc/bypassAccountOrder/ApiOrder',
          name: 'index',
          component: () =>
            import('@/views/pc/bypassAccountOrder/ApiOrder.vue'),
          meta: {
            title: '推广位订单',
            isRequireLogin: true,
          },
        }, {
          path: '/pc/bypassAccountOrder/miniOrder',
          name: 'index',
          component: () =>
            import('@/views/pc/bypassAccountOrder/miniOrder.vue'),
          meta: {
            title: '公众号订单',
            isRequireLogin: true,
          },
        }, {
          path: '/pc/bypassAccountOrder/officialOrder',
          name: 'index',
          component: () =>
            import('@/views/pc/bypassAccountOrder/officialOrder.vue'),
          meta: {
            title: '小程序订单',
            isRequireLogin: true,
          },
        },
        {
          path: '/pc/bypassAccountOrder/taobaoOrderError',
          name: 'index',
          component: () =>
            import('@/views/pc/bypassAccountOrder/taobaoOrderError.vue'),
          meta: {
            title: '淘宝订单人工纠错',
            isRequireLogin: true,
          },
        },
      ]
    },
    {
      path: '/pc/orderSearch/index',
      name: 'index',
      component: () =>
        import('@/views/pc/orderSearch/index.vue'),
      meta: {
        title: '淘宝订单查询',
        isRequireLogin: false,
      },
    },
    {
      path: '/pc/douyin/index',
      name: 'index',
      component: () =>
        import('@/views/pc/douyin/index.vue'),
      meta: {
        title: '抖音推广',
        isRequireLogin: false,
      },
      children: [
        {
          path: '/pc/douyin/home/index',
          name: 'douyinHome',
          component: () =>
            import('@/views/pc/douyin/home/index.vue'),
          meta: {
            title: '抖音推广',
            isRequireLogin: false,
          },
        },
        {
          path: '/pc/douyin/liveOrderList/index',
          name: 'douyinLiveOrderList',
          component: () =>
            import('@/views/pc/douyin/liveOrderList/index.vue'),
          meta: {
            title: '直播订单列表',
            isRequireLogin: false,
          },
        },
        {
          path: '/pc/douyin/financialDetails/index',
          name: 'douyinFinancialDetails',
          component: () =>
            import('@/views/pc/douyin/financialDetails/index.vue'),
          meta: {
            title: '资金明细',
            isRequireLogin: false,
          },
        },
        {
          path: '/pc/douyin/distribution/masterList',
          name: 'douyinMasterList',
          component: () =>
            import('@/views/pc/douyin/distribution/masterList.vue'),
          meta: {
            title: '达人列表',
            isRequireLogin: false,
          },
        },
        {
          path: '/pc/douyin/poiDistribution/philosopherList',
          name: 'douyinPoiPhilosopherListList',
          component: () =>
              import('@/views/pc/douyin/poiDistribution/philosopherList.vue'),
          meta: {
            title: '达人列表',
            isRequireLogin: false,
          },
        },
        {
          path: '/pc/douyin/poiDistribution/goods',
          name: 'douyinPoiGoods',
          component: () =>
              import('@/views/pc/douyin/poiDistribution/goods.vue'),
          meta: {
            title: '推广商品列表',
            isRequireLogin: false,
          },
        },
        {
          path: '/pc/douyin/poiDistribution/commission',
          name: 'douyinPoiCommissionList',
          component: () =>
              import('@/views/pc/douyin/poiDistribution/commission.vue'),
          meta: {
            title: '佣金列表',
            isRequireLogin: false,
          },
        },
        {
          path: '/pc/douyin/poiDistribution/cashFlow',
          name: 'douyinPoiCashFlow',
          component: () =>
              import('@/views/pc/douyin/poiDistribution/cashFlow.vue'),
          meta: {
            title: '资金流水',
            isRequireLogin: false,
          },
        },
        {
          path: '/pc/douyin/userData',
          name: 'douyinUserData',
          component: () =>
            import('@/views/pc/douyin/userData/index.vue'),
          meta: {
            title: '代理结佣管理',
            isRequireLogin: false,
          },
        },
        {
          path: '/pc/douyin/distribution/settle',
          name: 'douyinSettle',
          component: () =>
            import('@/views/pc/douyin/distribution/settle.vue'),
          meta: {
            title: '结算管理',
            isRequireLogin: false,
          },
        },
        {
          path: '/pc/douyin/help',
          name: 'douyinHelp',
          component: () =>
            import('@/views/pc/douyin/help'),
          meta: {
            title: '抖音引导页',
            isRequireLogin: false,
          },
        },
        {
          path: '/pc/douyin/proxyList/index',
          name: 'proxyList',
          component: () =>
            import('@/views/pc/douyin/proxyList/index'),
          meta: {
            title: '代理列表',
            isRequireLogin: false,
          },
        }
      ]
    },
    {
      path: '/pc/kuaishou/index',
      name: 'index',
      component: () =>
        import('@/views/pc/kuaishou/index.vue'),
      meta: {
        title: '快手推广',
        isRequireLogin: false,
      },
      children: [



        {
          path: '/pc/kuaishou/groupOrderList/index',

          name: 'kuaishouGroupOrderList',
          component: () =>
            import('@/views/pc/kuaishou/groupOrderList/index.vue'),
          meta: {
            title: '团购核销列表',
            isRequireLogin: false,
          },
        },
        {
          path: '/pc/kuaishou/home/index',
          name: 'kuaishouHome',
          component: () =>
            import('@/views/pc/kuaishou/home/index.vue'),
          meta: {
            title: '数据概况',
            isRequireLogin: false,
          },
        },
        {
          path: '/pc/kuaishou/financialDetails/index',
          name: 'kuaishouFinancialDetails',
          component: () =>
            import('@/views/pc/kuaishou/financialDetails/index.vue'),
          meta: {
            title: '分佣明细',
            isRequireLogin: false,
          },
        },
        {
          path: '/pc/kuaishou/liveOrderList/index',

          name: 'kuaishouLiveOrderList',
          component: () =>
            import('@/views/pc/kuaishou/liveOrderList/index.vue'),
          meta: {
            title: '直播订单列表',
            isRequireLogin: false,
          },
        },

      {
        path: '/pc/kuaishou/distribution/masterList',
        name: 'kuaishouMasterList',
        component: () =>
          import('@/views/pc/kuaishou/distribution/masterList.vue'),
        meta: {
          title: '达人列表',
          isRequireLogin: false,
        },
      },
      {
        path: '/pc/kuaishou/distribution/settle',
        name: 'kuaishouDistribution',
        component: () =>
          import('@/views/pc/kuaishou/distribution/settle.vue'),
        meta: {
          title: '达人结佣',
          isRequireLogin: false,
        },
      },

      {
        path: '/pc/kuaishou/help',
        name: 'kuaishounHelp',
        component: () =>
          import('@/views/pc/kuaishou/help'),
        meta: {
          title: '快手引导页',
          isRequireLogin: false,
        },
      },
      {
        path: '/pc/kuaishou/userData',
        name: 'kuaishouUserData',
        component: () =>
          import('@/views/pc/kuaishou/userData/index.vue'),
        meta: {
          title: '代理结佣管理',
          isRequireLogin: false,
        },
      },
      {
        path: '/pc/kuaishou/proxyList/index',
        name: 'kuaishouproxyList',
        component: () =>
          import('@/views/pc/kuaishou/proxyList/index'),
        meta: {
          title: '代理列表',
          isRequireLogin: false,
        },
      },

    ]
  },
    // ====渠道商成
    {
      path: '/pc/channelMiniProgram/',
      name: 'index',
      component: () =>
        import('@/views/pc/channelMiniProgram/index.vue'),
      meta: {
        title: '我的小程序',
      },
      children: [
        {
          path: '/pc/channelMiniProgram/home',
          name: 'index',
          component: () =>
            import('@/views/pc/channelMiniProgram/home/index.vue'),
          meta: {
            title: '主页',
            isRequireLogin: true,
          },
        },
        {
          path: '/pc/channelMiniProgram/recharge',
          name: 'index',
          component: () =>
            import('@/views/pc/channelMiniProgram/recharge/index.vue'),
          meta: {
            title: '提现',
            isRequireLogin: true,
          },
        },
        {
          path: '/pc/channelMiniProgram/activate',
          name: 'index',
          component: () =>
            import('@/views/pc/channelMiniProgram/activate/index.vue'),
          meta: {
            title: '激活续费',
            isRequireLogin: true,
          },
        },
        {
          path: '/pc/channelMiniProgram/user',
          name: 'index',
          component: () =>
            import('@/views/pc/channelMiniProgram/user/index.vue'),
          meta: {
            title: '用户列表',
            isRequireLogin: true,
          },
        },
        {
          path: '/pc/channelMiniProgram/order',
          name: 'index',
          component: () =>
            import('@/views/pc/channelMiniProgram/order/index.vue'),
          meta: {
            title: '订单列表',
            isRequireLogin: true,
          },
        },
        {
          path: '/pc/channelMiniProgram/intercept',
          name: 'index',
          component: () =>
            import('@/views/pc/channelMiniProgram/intercept/index.vue'),
          meta: {
            title: '拦截订单列表',
            isRequireLogin: true,
          },
        }, {
          path: '/pc/channelMiniProgram/audit',
          name: 'index',
          component: () =>
            import('@/views/pc/channelMiniProgram/audit/index.vue'),
          meta: {
            title: '提现审核',
            isRequireLogin: true,
          },
        },
        {
          path: '/pc/channelMiniProgram/set',
          name: 'index',
          component: () =>
            import('@/views/pc/channelMiniProgram/set/index.vue'),
          meta: {
            title: '基础设置',
            isRequireLogin: true,
          },
        }, {
          path: '/pc/channelMiniProgram/financialDetails',
          name: 'index',
          component: () =>
            import('@/views/pc/channelMiniProgram/financialDetails/index.vue'),
          meta: {
            title: '资金明细',
            isRequireLogin: true,
          },
        },
        {
          path: '/pc/channelMiniProgram/coupon',
          name: 'index',
          component: () =>
            import('@/views/pc/channelMiniProgram/coupon/index.vue'),
          meta: {
            title: '优惠券管理',
            isRequireLogin: true,
          },
        }, {
          path: '/pc/channelMiniProgram/promotionManage',
          name: 'index',
          component: () =>
            import('@/views/pc/channelMiniProgram/promotionManage/index.vue'),
          meta: {
            title: '推广位管理',
            isRequireLogin: true,
          },
        },
        {
          path: '/pc/channelMiniProgram/statisticalData',
          name: 'index',
          component: () =>
            import('@/views/pc/channelMiniProgram/statisticalData/index.vue'),
          meta: {
            title: '统计数据',
            isRequireLogin: true,
          },
        },
        {
          path: '/pc/channelMiniProgram/couponGroup',
          name: 'index',
          component: () =>
            import('@/views/pc/channelMiniProgram/couponGroup/index.vue'),
          meta: {
            title: '支付宝优惠券',
            isRequireLogin: true,
          },
        },
        {
          path: '/pc/channelMiniProgram/couponGroupNew',
          name: 'index',
          component: () =>
            import('@/views/pc/channelMiniProgram/couponGroupNew/index.vue'),
          meta: {
            title: '支付宝优惠券',
            isRequireLogin: true,
          },
        },
      ]
    },
    {
      path: '/pc/channelMiniProgram/auto',
      name: 'index',
      component: () =>
        import('@/views/pc/channelMiniProgram/auto/index.vue'),
      meta: {
        title: '授权小程序',
        isRequireLogin: true,
      },
    }
    , {
      path: '/pc/channelMiniProgram/pay',
      name: 'index',
      component: () =>
        import('@/views/pc/channelMiniProgram/pay/index.vue'),
      meta: {
        title: '支付订单',
        isRequireLogin: true,
      },
    }, {
      path: '/pc/channelMiniProgram/creditCard',
      name: 'index',
      component: () =>
        import('@/views/pc/channelMiniProgram/creditCard/index.vue'),
      meta: {
        title: '购买席位',
        isRequireLogin: true,
      },
    },
  ]
})

router.beforeEach((to, from, next) => {
  let params = to.query
  if (params.method && params.method === 'alipay.trade.page.pay.return') {
    // 从支付宝返回的参数
    //  //获取开放平台用户已购套餐与公众号信息（第一条数据为默认公众号）
    //获取开放平台用户已购套餐与公众号信息（第一条数据为默认公众号）
    let openUserUuid = getUserUUID() ? getUserUUID() : '';
    officialModel.publicLogin({openUserUuid: openUserUuid}).then((response) => {
      let res = response.data
      if (res.code != 200) {
        return
      }
      if (res.data.binds.length > 0) {
        let tempSnapshotId = getSnaphotId()
        let defaultOfficial = res.data.binds[0];
        if (tempSnapshotId) {
          let targetSnapshotId = tempSnapshotId
          if (targetSnapshotId == -1) {
            // targetSnapShotId = -1 表示刚刚添加的公众号 买了套餐
            let lastOfficial = res.data.binds.length
            defaultOfficial = res.data.binds[lastOfficial - 1];
          } else {
            let i;
            let tempData;
            for (i = 0; i < res.data.binds.length; i++) {
              tempData = res.data.binds[i]
              if (tempData['snapshotId'] == targetSnapshotId) {
                defaultOfficial = tempData
                break;
              }
            }
          }

        }
        setPlatformUuid(defaultOfficial.platformUuid);
        setPlatformName(defaultOfficial.platformName)
        if (defaultOfficial.snapshotId !== null) {
          setSnapshotId(defaultOfficial.snapshotId)
        } else {
          setSnapshotId(0)
        }
        setIsOver(defaultOfficial.isOver)
        setHeadImg(defaultOfficial.headImg)
        if (defaultOfficial.isProfit === 1) {
          setIsBasic(false)
        } else {
          setIsBasic(true)
        }
        if (defaultOfficial.packageName !== null) {
          setHasPackage(true)
        } else {
          setHasPackage(false)
        }
        if (defaultOfficial.platformUuid !== '' && defaultOfficial.platformName !== '') {
          setIsAuthOfficial(true)
        } else {
          setIsAuthOfficial(false)
        }
      }
      next()
    }).catch(error => {
      next()
    })

  } else {
    //document.getElementById('title').innerHTML = to.meta.title === undefined ? '电影票开放平台' : to.meta.title

    if (to.meta.isRequireLogin) {
      if (getToken()) {
        //通过封装好的cookies读取token，如果存在，name接下一步如果不存在，那跳转回登录页
        var type = (to.meta.activeIndex === undefined) ? 0 : to.meta.activeIndex
        if (type != store.getters.activeIndex) {
          store.dispatch('nav/changeActiveIndex', type)
        }
        next() //不要在next里面加"path:/",会陷入死循环
      } else {
        if (to.meta.activeIndex === 6) {
          store.dispatch('nav/changeActiveIndex', 6)
          next({
            path: '/pc/kfc/home'
          })
        } else if (to.meta.activeIndex === 8) {
          store.dispatch('nav/changeActiveIndex', 8)
          next({
            path: '/pc/open/login'
          })
        } else {
          store.dispatch('nav/changeActiveIndex', 0)
          next({
            path: '/pc/home'
          })
        }
      }
    } else {
      var type = (to.meta.activeIndex === undefined) ? 0 : to.meta.activeIndex
      if (type != store.getters.activeIndex) {
        store.dispatch('nav/changeActiveIndex', type)
      }
      if (getToken() && to.path === '/pc/kfc/home') {
        next({path: '/pc/kfc/statistics'})
      } else {
        next()
      }

    }
  }


})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js